import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { CustomTooltip, CustomXAxisTick, useTooltipToggle } from '../shared';

interface TemperatureChartProps {
  data: any[];
}

/**
 * 体温グラフコンポーネント
 */
export const TemperatureChart: React.FC<TemperatureChartProps> = ({ data }) => {
  const { tooltipActive, handleChartClick, handleChartLeave } = useTooltipToggle();

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        data={data}
        margin={{ top: 20, right: 20, left: -25, bottom: 20 }}
        onClick={handleChartClick}
        onMouseLeave={handleChartLeave}
      >
        <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
        <XAxis
          dataKey="date"
          tick={<CustomXAxisTick />}
          stroke="#666"
          interval={0}
        />
        <YAxis
          domain={[35, 40]}
          tick={{ fontSize: 16, fontWeight: 'bold' }}
          stroke="#666"
          axisLine={false}
          tickLine={false}
        />
        <Tooltip content={<CustomTooltip chartData={data} />} active={tooltipActive} trigger="click" />
        <Line
          type="linear"
          dataKey="temperature"
          name="体温"
          stroke="#808080"
          strokeWidth={2}
          dot={{ fill: '#808080', r: 7, stroke: '#ffffff', strokeWidth: 1 }}
          activeDot={tooltipActive ? { r: 9 } : false}
          connectNulls
          animationDuration={600}
          animationEasing="ease-out"
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default TemperatureChart;
